// A deep link into the search surface that carries a search: marketing and
// guide links pre-fill the name or facility, and a logged-in visitor may
// reload one or arrive from the marketing site with a new search. Boot-time
// redirects to the contact list must leave it alone, or the URL and its
// params are lost. What counts is a search path with one of the pre-fill
// params (or the legacy `first-search` marker) carrying a value — a bare
// search path, or one with only attribution params, still follows the boot
// rule: the search is what signals intent. Read from the location, never
// from a route snapshot: the router's initial navigation may not have
// activated yet when auth resolves.
export const isSearchDeepLink = (
  location: { pathname: string; search: string } = window.location,
): boolean =>
  /^\/(search|add-penmate|find-an-inmate)(\/|$)/i.test(location.pathname) &&
  /[?&](first_name|last_name|state|facility_state|facility_id|facility_slug|first-search)=[^&]+/i.test(
    location.search,
  );
